import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';

import { Menu, MenuItem, IconButton, ListItemText } from '@mui/material';

TicketsMoreMenu.propTypes = {
  handleUser: PropTypes.object,
  handleClicks: PropTypes.func,
  sx: PropTypes.object
};

export default function TicketsMoreMenu({ handleUser: _handleUser, handleClicks, sx }) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <IconButton
        data-testid="ticket_more_menu"
        sx={{ ...sx }}
        ref={ref}
        onClick={() => setIsOpen(true)}
      >
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          onClick={() => {
            setIsOpen(false);
            handleClicks('update_ticket');
          }}
          sx={{ color: 'text.secondary' }}
        >
          <ListItemText primary="Update Ticket" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>
        <MenuItem
          onClick={() => {
            setIsOpen(false);
            handleClicks('visit_merchant');
          }}
          sx={{ color: 'text.secondary' }}
        >
          <ListItemText
            primary="Visit Merchant Profile"
            primaryTypographyProps={{ variant: 'body2' }}
          />
        </MenuItem>
      </Menu>
    </>
  );
}
